/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountCredentialsForAzureStack extends models.ServiceAccountCredentialsBase {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountCredentialsForAzureStack");
    }

    getFixupPrototypeFunction() { return ServiceAccountCredentialsForAzureStack.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountCredentialsForAzureStack>): ServiceAccountCredentialsForAzureStack {
        let obj = Object.assign(new ServiceAccountCredentialsForAzureStack(), model);
        ServiceAccountCredentialsForAzureStack.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountCredentialsForAzureStack>): ServiceAccountCredentialsForAzureStack {
        if (!model) return null;
        return ServiceAccountCredentialsForAzureStack.newInstance(<ServiceAccountCredentialsForAzureStack> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountCredentialsForAzureStack) {
        if (!obj) return;

        models.ServiceAccountCredentialsForAzureStack.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountCredentialsForAzureStack): boolean {
        if (models.ServiceAccountCredentialsBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountCredentialsForAzureStack.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Tenant Id. This is a required field.
     */
    tenant_id: string;

    /**
     * Application Id. This is a required field.
     */
    application_id: string;

    /**
     * Application Secret. This is a required field.
     */
    application_secret: string;

    /**
     * Authentication Endpoint. This is a required field.
     */
    azurestack_endpoint: string;

    /**
     * Resource Endpoint. This is a required field.
     */
    resource_endpoint: string;

}
